import {
  FETCH_TINS_DETAILS_REQUEST,
  FETCH_TINS_DETAILS_SUCCESS,
  FETCH_TINS_DETAILS_FAILURE,
  SAVE_CUSTOM_LIST_REQUEST,
  SAVE_CUSTOM_LIST_SUCCESS,
  SAVE_CUSTOM_LIST_FAILURE,
  ADD_SINGLE_TIN_TO_LIST_REQUEST,
  ADD_SINGLE_TIN_TO_LIST_SUCCESS,
  ADD_SINGLE_TIN_TO_LIST_FAILURE,
  ADD_MORE_TINS_DATA_REQUEST,
  ADD_MORE_TINS_DATA_SUCCESS,
  ADD_MORE_TINS_DATA_FAILURE,
} from '@src/middleware/actions/actionTypes';
import { call, put, takeLatest } from 'redux-saga/effects';
import { debounce } from 'redux-saga/effects';
// import { fetchTinsDetailsService } from '@src/middleware/services/hiVolumeTins/hiVolumeTinsservice';
import {
  fetchTinsDetailsService,
  saveCustomListService,
  fetchAddMoreTinsData,
} from '@src/middleware/services/hiVolumeTins/hiVolumeTinsservice';

function* fetchTinsDetailsSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(fetchTinsDetailsService, action.payload);
    if (response && response?.StatusCode === 200) {
      yield put({ type: FETCH_TINS_DETAILS_SUCCESS, payload: response });
    } else if (response && response?.StatusCode) {
      yield put({
        type: FETCH_TINS_DETAILS_FAILURE,
        payload: `Error: Received status code ${response.StatusCode}`,
      });
    } else {
      yield put({
        type: FETCH_TINS_DETAILS_FAILURE,
        payload: 'Failed to fetch TINs details due to unexpected response structure',
      });
    }
  } catch (error) {
    if (error.name === 'NetworkError') {
      yield put({ type: FETCH_TINS_DETAILS_FAILURE, payload: 'Network error occurred' });
    } else if (error.name === 'TimeoutError') {
      yield put({ type: FETCH_TINS_DETAILS_FAILURE, payload: 'Request timed out' });
    } else {
      yield put({ type: FETCH_TINS_DETAILS_FAILURE, payload: error.message || 'An unknown error occurred' });
    }
  }
}

function* saveCustomListSaga(action: any): Generator<any, void, any> {
  try {
    // Assuming saveCustomListService is defined similarly to fetchTinsDetailsService
    const response = yield call(saveCustomListService, action.payload);
    // Handle success response if needed
    // if (response && response?.StatusCode === 200) {
    yield put({ type: SAVE_CUSTOM_LIST_SUCCESS, payload: response });
    // } else {
    // console.error('Error saving custom list:', response);
    // Handle error response if needed
    // yield put({ type: SAVE_CUSTOM_LIST_FAILURE, payload: 'Failed to save custom list' });
    // }
  } catch (error) {
    if (error.name === 'NetworkError') {
      yield put({ type: SAVE_CUSTOM_LIST_FAILURE, payload: 'Network error occurred' });
    } else if (error.name === 'TimeoutError') {
      yield put({ type: SAVE_CUSTOM_LIST_FAILURE, payload: 'Request timed out' });
    } else {
      yield put({ type: SAVE_CUSTOM_LIST_FAILURE, payload: error.message || 'An unknown error occurred' });
    }
  }
}

function* setAddMoreTinsSearchSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(fetchAddMoreTinsData, action.payload);
    if (response && response?.StatusCode === 200) {
      if (response?.Data) {
        yield put({ type: ADD_MORE_TINS_DATA_SUCCESS, payload: response });
      } else {
        yield put({
          type: ADD_MORE_TINS_DATA_FAILURE,
          payload: 'Malformed response: Expected data to be an array',
        });
      }
    } else if (response && response?.StatusCode) {
      yield put({
        type: ADD_MORE_TINS_DATA_FAILURE,
        payload: `Error: Received status code ${response.StatusCode}`,
      });
    } else {
      yield put({
        type: ADD_MORE_TINS_DATA_FAILURE,
        payload: 'Failed to fetch add more TINs data due to unexpected response structure',
      });
    }
  } catch (error) {
    if (error.name === 'NetworkError') {
      yield put({ type: ADD_MORE_TINS_DATA_FAILURE, payload: 'Network error occurred' });
    } else if (error.name === 'TimeoutError') {
      yield put({ type: ADD_MORE_TINS_DATA_FAILURE, payload: 'Request timed out' });
    } else if (error instanceof SyntaxError) {
      yield put({ type: ADD_MORE_TINS_DATA_FAILURE, payload: 'Malformed response: Syntax error in payload' });
    } else {
      yield put({ type: ADD_MORE_TINS_DATA_FAILURE, payload: error.message || 'An unknown error occurred' });
    }
  }
}

function* addSingleTinToList(action: any): Generator<any, void, any> {
  try {
    if (!action.payload || typeof action.payload !== 'object') {
      throw new Error('Invalid payload: Expected an object');
    }
    // Simulate a service call or any other logic if needed
    // For example: const response = yield call(addSingleTinService, action.payload);
    yield put({
      type: ADD_SINGLE_TIN_TO_LIST_SUCCESS,
      payload: action.payload,
    });
  } catch (error) {
    yield put({ type: ADD_SINGLE_TIN_TO_LIST_FAILURE, payload: error.message });
  }
}

export function* hiVolumeTinsSaga() {
  yield takeLatest(FETCH_TINS_DETAILS_REQUEST, fetchTinsDetailsSaga);
  yield takeLatest(SAVE_CUSTOM_LIST_REQUEST, saveCustomListSaga);
  yield debounce(3000, ADD_MORE_TINS_DATA_REQUEST, setAddMoreTinsSearchSaga);
  yield takeLatest(ADD_SINGLE_TIN_TO_LIST_REQUEST, addSingleTinToList);
}
